import React from "react";
import ContactView from "../../contacts/ContactView";

const ContactsStep: React.FC = () => {
  return <ContactView isOnboarding={true} />;
};

export default ContactsStep;
